import { useContext, useEffect } from "react";
import { NavContext } from "../contexts/NavContextProvider";
import { updateDocumentTitle } from "..";
import SubPageTitle from "../SubPageTitle";
import { BoardFilled } from "@fluentui/react-icons";

export default function DashboardPage() {
    const { navData, setNavData } = useContext(NavContext);

    useEffect(
        () => {
            updateDocumentTitle( "Dashboard | Overview" );
            navData.sidebarSelectedNavValue = "dashboard";
            navData.subPageNavValue = null;
            setNavData({...navData});
        },
        []
    );

    return (
        <>
            <SubPageTitle icon={<BoardFilled />} title="Dashboard" subTitle="Overview" />
            <p>
                Coming soon.
            </p>
        </>
    );
}